import React, { useState } from 'react';
import Link from 'next/link';
import { AxiosError } from 'axios';
import Icon from '@components/common/assets';
import Alert from '@components/common/alert';
import { useToast } from '@components/common/toast';
import { useEventsProfileApply, useEventsParticipationStatus } from '@repository/event/useEvent';
import { useUserInfo } from '@repository/auth/useUserInfo';
import EventProfileApplyModal, { ModalState } from './modal';
import { EventTypeEnum } from '@domain/constant/event/EventType';
import Colors from '@domain/constant/colors';
import { RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

const HowTo = () => {
  const Toast = useToast();
  const [modalState, setModalState] = useState<ModalState>(null);
  const openModal = (type: ModalState) => setModalState(type);

  const { data: userInfo } = useUserInfo();
  const isLogin = !!userInfo?.id;
  const { refetch } = useEventsParticipationStatus(EventTypeEnum.PROFILE_EVENT_2023_12);

  //이벤트 신청 에러 처리
  const handleApplyError = (e: AxiosError) => {
    switch (e?.response?.data.errorCode) {
      case 'B901':
        return Alert({
          title: '응모실패',
          desc: <>휴대폰 번호가 존재하지 않습니다.</>,
          dimmed: true,
          onClickBgClose: false,
        });
      case 'B903':
        return Alert({
          title: '이미 이벤트에 응모하셨습니다.',
          desc: (
            <>
              당첨 확률을 높이기 위해
              <br />
              프로필을 업데이트해보세요.
            </>
          ),
          dimmed: true,
          onClickBgClose: false,
        });
      case 'B904':
      case 'B905':
        return openModal('MARKETING_POLICY_AGREE');
      case 'B907':
        return Alert({
          title: '프로필 필수값 미입력',
          desc: (
            <>
              이벤트 조건을 만족한 후 응모가 가능합니다.
              <br />
              프로필 필수정보 작성 후 응모해주세요.
            </>
          ),
          dimmed: true,
          onClickBgClose: false,
        });
      default:
        return Toast({ type: 'error', iconType: 'info', content: e.response?.data.message });
    }
  };

  //이벤트 응모 api 호출
  const { mutateAsync: applyEvent } = useEventsProfileApply(() => {
    refetch();
    Alert({
      title: '응모완료!',
      desc: (
        <>
          당첨될 경우 네이버페이는
          <br />
          회원정보 상 전화번호로 발송됩니다.
          <br />
          프로필 완성도가 높고
          <br />
          내용이 상세할수록 당첨 확률이 올라갑니다.
        </>
      ),
      dimmed: true,
      onClickBgClose: false,
    });
  }, handleApplyError);

  //이벤트 응모 버튼 클릭
  const clickApplyButton = () => {
    if (!isLogin) {
      openModal('LOGIN');
      return;
    }
    applyEvent();
  };

  return (
    <div className={cx('commonBox', 'whiteTag')}>
      {/* 타이틀 */}
      <div className={cx('basicTitleInner')}>
        <span className={cx('basicTitle')}>프로필 신규 작성/업데이트만 해도</span>
        <span className={cx('subTitle')}>JOBDA가 취업지원금 총 120만원을 지원합니다!</span>
      </div>

      <span className={cx('titleInfo')}>[이벤트 응모하기] 버튼을 클릭해서 응모해주세요.</span>

      <div className={cx('contentInner')}>
        <div className={cx('naverPay')}>
          <span className={cx('giftBox')}>
            신세계백화점 상품권
            <strong> 10만원(2명)</strong>
          </span>
          <span className={cx('giftBox')}>
            네이버페이 5천원
            <strong>(200명)</strong>
          </span>
        </div>
      </div>

      {/* [D] 이벤트 참여 버튼 */}
      <div className={cx('joinArea')}>
        <Link className={cx('btnLink')} href={RouteUrl.PROFILE} target="_blank">
          프로필 신규 작성 / 업데이트 하기
          <Icon name="guideLight" width={32} height={32} fill={Colors.C_JOBDA_BLACK} />
        </Link>
        <button className={cx('btnLink', 'btnJoin')} onClick={clickApplyButton} disabled>
          이벤트 응모하기
        </button>
      </div>

      <span className={cx('eventInfo')}>
        * 프로필 입력 완료 후 [이벤트 응모하기] 버튼을 누르면 이벤트에 응모가 완료됩니다.
        <br />
        * 이벤트 참여를 위한 마케팅 정보 수신 동의가 필요합니다.
        <br />* 프로필 완성도가 높을 수록, 프로필 내용을 상세하게 입력하실 수록 당첨 확률이 높아집니다.
      </span>

      <EventProfileApplyModal modalState={modalState} setModalState={setModalState} />
    </div>
  );
};

export default HowTo;
